import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from './components/Dashboard';
import { Compliance } from './pages/Compliance';
import { ComplianceNews } from './components/ComplianceNews';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-gray-50" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Navigate to="/compliance" replace data-id="element-4" />} data-id="element-3" />
          <Route path="/dashboard" element={<Dashboard data-id="element-6" />} data-id="element-5" />
          <Route path="/compliance" element={<Compliance data-id="element-8" />} data-id="element-7" />
        </Routes>
      </div>
    </BrowserRouter>;
}